import { WorkspaceState } from './types';

/**
 * 工作区状态的初始值
 */
export const initialWorkspaceState: WorkspaceState = {
  documents: {},
  folders: {
    root: {
      id: 'root',
      name: '我的文档',
      documents: [],
      children: [],
      createdAt: Date.now(),
      parentId: null
    },
  },
  activeDocumentId: null,
  activeFolderId: 'root',
  openDocuments: [],
}; 